var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNamecard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/namecard"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M19 12h-5.5m2 3.5h-2M11 16c0-3.165-6-3.165-6 0m12.5-7.5h-4M6.2 9.946c0 2.595 3.6 2.595 3.6 0s-3.6-2.595-3.6 0ZM6 21h12a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamecard);
export default __webpack_public_path__ + "static/media/namecard.685f7468c07c7d7ce32f5cdd27ccc128.svg";
export { ForwardRef as ReactComponent };